"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var SvgRead = function (props) { return (React.createElement("svg", __assign({ "data-testid": "ICON_READ", width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M15.669.257a1 1 0 0 1 .074 1.412l-3 4a1 1 0 0 1-1.45.038l-2-2a1 1 0 0 1 1.414-1.414l1.255 1.255L14.257.33a1 1 0 0 1 1.412-.074Z" }),
    React.createElement("path", { d: "M16 6.327v8.392c0 .46-.314.85-.768.915C14.183 15.781 11.965 16 8 16c-3.965 0-6.183-.218-7.232-.367C.314 15.57 0 15.178 0 14.72V6a1 1 0 0 1 .419-.814L6.755.661a4 4 0 0 0-.707 2.962L2.72 6 8 9.771 9.907 8.41a4 4 0 0 0 2.672.549l-3.998 2.856a1 1 0 0 1-1.162 0L2 7.944v5.821C3.176 13.88 5.094 14 8 14s4.824-.12 6-.235v-5.3c.36-.209.69-.474.973-.79.06-.066.117-.135.17-.206L16 6.327Z" }))); };
exports.default = SvgRead;
